module.exports = __webpack_public_path__ + "static/lr-web-demi.6cb1c8e4.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lr-web-demi.woff
// module id = 438
// module chunks = 114276838955818